import { render, staticRenderFns } from "./SharedMediaFolderTable.vue?vue&type=template&id=2a3c9338&"
import script from "./SharedMediaFolderTable.vue?vue&type=script&lang=js&"
export * from "./SharedMediaFolderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports